// Preact
import {h} from 'preact'
import {useState, useEffect} from 'preact/hooks'
// Bootstrap
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'

const GrowlNotification = ({children, variant = 'info', duration = 3000}) => {
  const [showNotification, setShowNotification] = useState(false)

  useEffect(() => {
    setShowNotification(true)

    if(duration > 0) {
      setTimeout(() => {
        setShowNotification(false)
      }, duration)
    }
  }, [])

  return(
    <Modal show={showNotification} onHide={() => setShowNotification(false)} backdrop={false} className="growl-notification">
      <Alert variant={variant} className="mb-0 text-center">
        {children}
      </Alert>
    </Modal>
  )
}

export default GrowlNotification


// WEBPACK FOOTER //
// ./client/resources/js/checkout/components/growl-notification.js